module.exports = __webpack_public_path__ + "img/ideal_crypto.png";